import React, { useState, useReducer, useMemo, useEffect } from 'react'
import { Segment, Form, Header, Input, Icon, Table } from 'semantic-ui-react'
import InputMask from 'react-input-mask'
import { toast } from 'react-toastify'
import { DateTime } from 'luxon'
import { finalize, tap } from 'rxjs/operators'
import { useSubscription, paramsToSearchURL } from 'utils'
import request from 'services/http'
import Tabela from './Tabela'
import history from 'services/history'

const initialFormValues = {
    rest: '01',
    dataInicio: '',
    dataFim: ''
}

function formReducer(state, action) {
    if ('reset' in action)
        return initialFormValues
    if (!('payload' in action))
        return state
    return { ...state, ...action.payload }
}

export default function Formulario(props) {

    const [form, setForm] = useReducer(formReducer, initialFormValues)
    const [dados, setDados] = useState([])
    const [isSubmitting, setIsSubmitting] = useState(true)
    const [loadingTable, setLoadingTable] = useState(false)
    const [restOptions,] = useState([
        { text: 'Restaurante Dom Pedro 1', value: '01' },
        { text: 'Restaurante Dom Pedro Atibaia', value: '04' },
        { text: 'Hotel Central', value: '08' },
    ])

    //GET RELATORIO
    const submitRelatorio$ = useMemo(() => request({
        url: `/conciliacao-cartao/conc-cartao-caixa${props.location.search}`,
        method: 'GET'
    }).pipe(
        tap(({ response }) => {
            if (response.data.length <= 0) {
                toast.error('Dados não encontrados.')
                return
            } else {
                setDados(response.data)
            }
        }),
        finalize(() => setIsSubmitting(false))
    ), [props.location.search])
    useSubscription(submitRelatorio$, props.location.search)

    function handleSubmit() {
        setIsSubmitting(true)
        if (!(!!form.dataInicio) || !(!!form.dataFim)) {
            toast.error('Por favor, informe as datas corretamente antes de prosseguir.')
            setIsSubmitting(false)
            return
        } else {
            let params = {};
            for (let param in form) {
                switch (param) {
                    case 'dataInicio':
                    case 'dataFim':
                        params[param] = DateTime.fromFormat(form[param], 'dd/MM/yyyy').toFormat('yyMMdd');
                        break;

                    case 'rest':
                        if (form[param]) {
                            params[param] = form[param];
                        }
                        break;

                    default:
                        if (form[param] || form[param] === '') {
                            params[param] = form[param];
                        }
                }
            }
            history.push({ search: paramsToSearchURL(params) });
        }
    }

    function handleChangeSelect(_, { name, value }) {
        setForm({ payload: { [name]: value } })
    }

    function handleChange(event) {
        let name, value
        [name, value] = [event.target.name, event.target.value]
        setForm({ payload: { [name]: value } })
    }

    useEffect(() => {
        if(!props.location.search){
            cleanPath()
            setIsSubmitting(false)
        }
    }, [props.location.search])

    const cleanPath = () => {
        history.push({ search: null });
        setDados([])
    }

    return (
        <div className="col d-flex align-items-center flex-column">
            <Segment basic textAlign='left' style={{ width: '100%', padding: '10px 0px' }}>
                <Form size={'tiny'} onSubmit={handleSubmit}>
                    <Form.Group>
                        <Form.Select
                            width='5'
                            label={
                                <Header as='h5' style={{ margin: 0, marginBottom: 5 }} color='orange'>Restaurante</Header>
                            }
                            options={restOptions}
                            search
                            selectOnBlur={false}
                            placeholder='Selecionar Restaurante'
                            name='rest'
                            value={form.rest}
                            onChange={handleChangeSelect}
                        />
                        <Form.Field width='4'>
                            <Header floated='left' as='h5' style={{ margin: 0, marginBottom: 5 }} color='orange'>Data</Header>
                            <Header floated='right' as='h5' style={{ margin: 0, marginBottom: 5, color: 'white' }}>-</Header>
                            <Input
                                children={
                                    <InputMask mask="99/99/9999" placeholder='Inicial' value={form.dataInicio} name='dataInicio' onChange={handleChange} />
                                }
                            />
                        </Form.Field>
                        <Form.Field width='4'>
                            <Header floated='right' as='h5' style={{ margin: 0, marginBottom: 5, color: 'white' }}>-</Header>
                            <Input
                                children={
                                    <InputMask mask="99/99/9999" placeholder='Final' value={form.dataFim} name='dataFim' onChange={handleChange} />
                                }
                            />
                        </Form.Field>
                        <Form.Button label={'\u00A0'} floated='right' width='2' icon title='Limpar Campos' type='button' onClick={() => {setForm({ reset: true }); cleanPath()}}>
                            <Icon name='trash' />
                        </Form.Button>
                        <Form.Button label={'\u00A0'} disabled={isSubmitting} floated='right' icon labelPosition='left' color='vk'>
                            <Icon name='arrow right' />
                            Enviar
                        </Form.Button>
                    </Form.Group>
                </Form>

                <Segment loading={isSubmitting || loadingTable} basic={true} style={{ margin: 0, padding: '0px 0px', marginBottom: '10px' }} textAlign='center'>
                    {dados.length > 0 ? (
                        <Tabela props={props} dados={dados} setDados={setDados} form={form} setLoadingTable={setLoadingTable} />
                    ) :
                        <Table color='grey' size='small' singleLine textAlign='center' compact='very'>
                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell>Data</Table.HeaderCell>
                                    <Table.HeaderCell>Turno</Table.HeaderCell>
                                    <Table.HeaderCell>Valor Caixa</Table.HeaderCell>
                                    <Table.HeaderCell>Valor Extrato Cartão</Table.HeaderCell>
                                    <Table.HeaderCell>Diferença</Table.HeaderCell>
                                </Table.Row>
                            </Table.Header>
                            <Table.Body>
                                <Table.Row>
                                    <Table.Cell colSpan='5' style={{ height: '50vh' }}>
                                        Preencha os campos acima para fazer uma busca!
                                    </Table.Cell>
                                </Table.Row>
                            </Table.Body>
                        </Table>
                    }
                </Segment>
            </Segment>
        </div>
    )
}